import { Box } from "@mui/material";

// This component is used as a layout container and should not need to be updated
export default function TPLSlidePanel({
  children,
}: {
  children: any;
}) {

  return (
    <Box
      className="left-panel__slide"
    >
      {children}
    </Box>
  );
}
